import TextField from "@mui/material/TextField";
import {Autocomplete} from "@mui/material";
import {ErrorMessage, Field, FormikProps, FormikValues, getIn, useField, useFormikContext} from "formik";


const durationOptions = ["15","30","45","60","90","120"];

export default function DurationPicker(props:any) {
    const { name, label, disabled } = props;
    const formik: FormikProps<FormikValues> = useFormikContext();
    const [field] = useField(props.name);
    const { setFieldValue } = useFormikContext();
    const handleChange = (event:any,newValue: string) => {
        setFieldValue(field.name, newValue);
    }

    return (
        <Autocomplete
            freeSolo
            options={durationOptions}
            defaultValue={field.value? field.value: ""}
            onInputChange = {handleChange}
            getOptionLabel={(option)=> option}
            renderInput={(params) => (
                <Field
                    as={TextField}
                    {...params}
                    fullWidth
                    name={name}
                    label={label}
                    helperText={<ErrorMessage name={name} />}
                    error={getIn(formik.touched, name) && getIn(formik.errors, name)}
                    disabled={disabled}
                />

            )}

        />
    );
}
